/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sub_Addons_Confirm_Downgrade_Desc_RemoveInputs */



/**
* | output |
* | --- |
* | "Your storage add-on will be removed on {date}. You keep your current storage until then." |
*
* @param {Sub_Addons_Confirm_Downgrade_Desc_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_downgrade_desc_remove = /** @type {((inputs: Sub_Addons_Confirm_Downgrade_Desc_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Downgrade_Desc_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Speicher-Zusatzpaket wird am ${i?.date} entfernt. Sie behalten Ihren aktuellen Speicher bis dahin.`)
	return /** @type {LocalizedString} */ (`Your storage add-on will be removed on ${i?.date}. You keep your current storage until then.`)
});